// Thin, init-safe wrappers around the RUM API. All calls are no-ops (and never
// throw) when RUM is not configured, so callers don't need to guard.
//
// `window.__rum` (not a module import) is intentional: this file is reachable
// from the always-mounted error boundaries (error.tsx, global-error.tsx), so a
// real import of `@openobserve/browser-rum` here would pull the SDK into
// every page's bundle regardless of analytics consent. See src/otel/rum-client.ts.

export function setTelemetryUser(user: { id?: string; name?: string; email?: string }): void {
  if (!user.id && !user.email) return
  window.__rum?.setUser(user)
}

// Current RUM session id, so it can be forwarded to the backend (header) and
// correlated with server-side spans/logs.
export function getRumSessionId(): string | undefined {
  return window.__rum?.getInternalContext()?.session_id
}

// Manually report an error to RUM (e.g. from a React error boundary, which
// otherwise never reaches window.onerror).
export function reportTelemetryError(error: unknown, context?: Record<string, unknown>): void {
  window.__rum?.addError(error, context)
}
